import React from 'react'
import "./header.css"
const Footer = () => {
  const date = new Date()
  return (
    <div className='footer'>Copyright © {date.getFullYear() } VIOSA.AI. All rights reserved.</div>
  )
}

export default Footer